import HotelsWithHighestGuestRating from './HotelsWithHighestGuestRating';

export default HotelsWithHighestGuestRating;
